export type SelectionListItem = {
  id: number
  label: string
}

export const settingsSelectionList: SelectionListItem[] = [
  { id: 0, label: 'My Company' },
  { id: 1, label: 'User Management' },
  { id: 2, label: 'Billing' },
  { id: 3, label: 'Custom Setting' },
]
